var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "100px",
    height: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M46,15v20c0,6.075-4.925,11-11,11H15C8.925,46,4,41.075,4,35V15C4,8.925,8.925,4,15,4h20C41.075,4,46,8.925,46,15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.394 19.226c0-.659.519-1.16 1.222-1.16s1.222.501 1.222 1.16c0 .65-.519 1.151-1.222 1.151S10.394 19.876 10.394 19.226zM10.675 22.056H12.556000000000001V31.627000000000002H10.675zM27.944 25.281c0 4.078-2.232 6.653-5.906 6.653-3.683 0-5.924-2.566-5.924-6.653 0-4.096 2.285-6.645 5.924-6.645C25.694 18.637 27.944 21.194 27.944 25.281zM18.127 25.281c0 2.927 1.477 4.816 3.911 4.816 2.408 0 3.894-1.89 3.894-4.816 0-2.944-1.485-4.808-3.894-4.808C19.647 20.474 18.127 22.337 18.127 25.281zM31.961 28.217c.167 1.204 1.345 1.969 3.041 1.969 1.582 0 2.742-.817 2.742-1.942 0-.967-.738-1.547-2.417-1.942l-1.635-.396c-2.294-.536-3.34-1.644-3.34-3.507 0-2.259 1.846-3.762 4.614-3.762 2.575 0 4.456 1.503 4.57 3.639H37.62c-.185-1.169-1.204-1.898-2.681-1.898-1.556 0-2.593.747-2.593 1.89 0 .905.668 1.424 2.32 1.811l1.397.343c2.602.606 3.674 1.661 3.674 3.568 0 2.426-1.881 3.946-4.887 3.946-2.812 0-4.702-1.45-4.843-3.718h1.954V28.217z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.2a16490a7e4e75b24aeaf993e33bf0b7.svg";
export { ForwardRef as ReactComponent };